<ng-container [ngSwitch]="testColumn.field">
  <span *ngSwitchCase="'testType'" genEllipsis genTooltip [tooltipText]="testRow.testType" [tooltipPosition]="'LEFT'"
        [tooltipShow]="testRow.typeTooltip"
        (tooltipStateEmit)="showTooltip($event,testRow,'typeTooltip')"
        class="property  Auto_Test_List_Item_testType">{{testRow.testType}}</span>
  <span *ngSwitchCase="'testNumber'" genEllipsis genTooltip [tooltipText]="testRow.testNumber"
        [tooltipPosition]="'LEFT'" [tooltipShow]="testRow.numberTooltip"
        (tooltipStateEmit)="showTooltip($event,testRow,'numberTooltip')"
        class="property  Auto_Test_List_Item_testNumber">{{testRow.testNumber}}</span>
  <span *ngSwitchCase="'revision'" genEllipsis genTooltip [tooltipText]="testRow.revision" [tooltipPosition]="'LEFT'"
        [tooltipShow]="testRow.revisionTooltip"
        (tooltipStateEmit)="showTooltip($event,testRow,'revisionTooltip')"
        class="property  Auto_Test_List_Item_revision">{{testRow.revision}}</span>
  <span *ngSwitchCase="'date'" genEllipsis genTooltip [tooltipText]="testRow.date|date:'dd MMM y'"
        [tooltipPosition]="'LEFT'"
        [tooltipShow]="testRow.dateTooltip" (tooltipStateEmit)="showTooltip($event,testRow,'dateTooltip')"
        class="property  Auto_Test_List_Item_date">{{testRow.date|date:'dd MMM y'}}</span>
  <span *ngSwitchCase="'status'" genEllipsis genTooltip [tooltipText]="testRow.status" [tooltipPosition]="'LEFT'"
        [tooltipShow]="testRow.statusTooltip"
        (tooltipStateEmit)="showTooltip($event,testRow,'statusTooltip')" class="property Auto_Test_List_Item_status">{{testRow.status | stringTranslate}}</span>
  <span *ngSwitchCase="'MRN'" genEllipsis genTooltip [tooltipText]="testRow.MRN" [tooltipPosition]="'LEFT'"
        [tooltipShow]="testRow.MRNTooltip"
        (tooltipStateEmit)="showTooltip($event,testRow,'MRNTooltip')"
        class="property  Auto_Test_List_Item_MRN">{{testRow.MRN}}</span>
</ng-container>
